function Download(props: any) {
  return (
    <svg
      className={props?.className}
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2681_3374)">
        <path
          d="M3.16797 11.332V12.6654C3.16797 13.019 3.30844 13.3581 3.55849 13.6082C3.80854 13.8582 4.14768 13.9987 4.5013 13.9987H12.5013C12.8549 13.9987 13.1941 13.8582 13.4441 13.6082C13.6942 13.3581 13.8346 13.019 13.8346 12.6654V11.332"
          stroke={props.color || "white"}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.16797 7.33203L8.5013 10.6654L11.8346 7.33203"
          stroke={props.color || "white"}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.5 2.66797V10.668"
          stroke={props.color || "white"}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2681_3374">
          <rect
            width="16"
            height="16"
            fill={props.color || "white"}
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Download;
